import produce from "immer";

import {
  AUTH_WATCH,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAIL
} from "../actions/types";

const initialState = {
  user: null,
  loginFail: null
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case AUTH_WATCH:
        draft.user = action.payload;
        draft.loginFail = null;
        break;
      case AUTH_LOGIN_SUCCESS:
        draft.user = action.payload.user;
        draft.loginFail = null;
        break;
      case AUTH_LOGIN_FAIL:
        draft.user = null;
        draft.loginFail = action.payload;
        break;
    }
  });
};
